/* Cart drawer extras: animated rewards bar, Frequently Bought Together, discount code field.
   Each is a custom element, so it re-initialises whenever Dawn re-renders the drawer HTML. */
(() => {
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const store = {
    get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del: (k) => { try { sessionStorage.removeItem(k); } catch (e) {} },
  };
  const drawer = () => document.querySelector('cart-drawer');
  const sectionIds = () => {
    const d = drawer();
    return d && d.getSectionsToRender ? d.getSectionsToRender().map((s) => s.id) : ['cart-drawer', 'cart-icon-bubble'];
  };
  const afterCartChange = (res, source) => {
    const d = drawer();
    if (d) d.classList.remove('is-empty');
    if (d && d.renderContents) d.renderContents(res);
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source, cartData: res });
    }
  };

  if (!customElements.get('reward-bar')) {
    customElements.define('reward-bar', class extends HTMLElement {
      connectedCallback() {
        const fill = this.querySelector('.reward-bar__fill');
        if (!fill) return;
        const to = parseFloat(this.dataset.pct) || 0;
        const prev = store.get('oraRewardPct');
        const from = prev === null ? to : parseFloat(prev);
        fill.style.width = from + '%';
        requestAnimationFrame(() => requestAnimationFrame(() => { fill.style.width = to + '%'; }));
        store.set('oraRewardPct', String(to));
        if (to > from) this.classList.add('is-pop');
      }
    });
  }

  if (!customElements.get('cart-fbt')) {
    customElements.define('cart-fbt', class extends HTMLElement {
      async connectedCallback() {
        const pid = this.dataset.productId;
        if (!pid || this.dataset.loaded) return;
        this.dataset.loaded = '1';
        const base = `${this.dataset.url}?section_id=cart-fbt&product_id=${pid}&limit=8`;
        const load = async (url) => new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
        try {
          let doc = await load(`${base}&intent=complementary`);
          if (!doc.querySelector('.cart-fbt__item')) doc = await load(base);
          const box = doc.querySelector('.cart-fbt');
          if (!box || !box.querySelector('.cart-fbt__item')) return;
          this.innerHTML = box.outerHTML;
          this.addEventListener('click', (e) => this.onAdd(e));
        } catch (e) { /* recommendations are optional */ }
      }
      async onAdd(e) {
        const btn = e.target.closest('.cart-fbt__add');
        if (!btn || btn.disabled) return;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(`${root()}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(btn.dataset.variantId), quantity: 1, sections: sectionIds(), sections_url: window.location.pathname }),
          }).then((r) => r.json());
          if (res.status) throw new Error(res.description || 'add failed');
          afterCartChange(res, 'cart-fbt');
        } catch (err) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = 'Unavailable';
        }
      }
    });
  }

  if (!customElements.get('cart-discount')) {
    customElements.define('cart-discount', class extends HTMLElement {
      connectedCallback() {
        const msg = this.querySelector('.cart-discount__msg');
        const saved = store.get('oraDiscountMsg');
        if (saved && msg) {
          const [ts, state, text] = saved.split('|');
          if (Date.now() - Number(ts) < 8000) { msg.textContent = text; msg.dataset.state = state; }
          else store.del('oraDiscountMsg');
        }
        const form = this.querySelector('form');
        if (!form) return;
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const input = this.querySelector('input');
          const code = input.value.trim();
          if (!code) return;
          const btn = this.querySelector('button');
          btn.disabled = true;
          try {
            const cart = await (await fetch(`${root()}cart.js`)).json();
            const codes = [...new Set([...(cart.discount_codes || []).map((d) => d.code), code])];
            const update = (list) => fetch(`${root()}cart/update.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: list.join(','), sections: sectionIds(), sections_url: window.location.pathname }),
            }).then((r) => r.json());
            let res = await update(codes);
            const hit = (res.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
            const ok = !!(hit && hit.applicable);
            if (!ok) res = await update(codes.filter((c) => c.toLowerCase() !== code.toLowerCase())); // don't leave a dead code on the cart
            store.set('oraDiscountMsg', `${Date.now()}|${ok ? 'ok' : 'err'}|${code.toUpperCase()} ${ok ? 'applied' : "can't be used on this cart"}`);
            afterCartChange(res, 'cart-discount');
          } catch (err) {
            btn.disabled = false;
            if (msg) { msg.textContent = 'Something went wrong. Please try again.'; msg.dataset.state = 'err'; }
          }
        });
      }
    });
  }
})();
